var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.OnlineOrdersHistory.Messages.GetOrderDetails, Vendd.OnlineOrdersHistory, function (envelope) {
        var options = {
            url: 'api/OnlineOrdersHistory/GetOrderDetails',
            data: {
                orderId: envelope.message.data,
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            var model = {
                Order: response.data.Orders ? response.data.Orders [0] : null,
                Translators: response.data.Translators
            };

            Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.OnlineOrdersHistory.Messages.GetOrderDetailsSuccess(model));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.OnlineOrdersHistory.Messages.GetOrderDetailsFailure(response));
        }

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});
